export default {
	login: 'Giriş'
}